import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
// import { parse } from 'ts-node';

@Pipe({
  name: 'arrayFilter'
})
export class ArrayFilter implements PipeTransform {

  transform(value: any, field: string = '', tobe: any) {
    if (Array.isArray(value) && field !== '') {
      return value.filter((x) => x[field] === tobe);
    } else return value;
  }

}

@Pipe({
  name: 'arrayObjectSort'
})

export class ArrayObjectSort implements PipeTransform {
  transform(value, type) {
    if (type === "reverse") return [...value].reverse();
    else return [...value].sort();
  }
}

@Pipe({
  name: 'reverseArray'
})

export class ReverseArrayPipe implements PipeTransform {
  transform(value) {
    return value.slice().reverse();
  }
}

@Pipe({
  name: 'decimalToTime'
})
export class DecimalToTime implements PipeTransform {

  transform(decimal: any) {
    if (typeof decimal === 'number' && decimal > 0 && decimal < 24) {
      console.log(' ssss', decimal);
      const str = ('' + decimal).split('.');
      if (str[1] === undefined) str[1] = '0';
      const hh = str[0].length === 1 ? '0' + str[0] : str[0];
      const min = str[1].length === 1 ? str[1] + '0' : str[1];
      return hh + ':' + min;
    } else {
      return 'ERR'
    }
  }
}

@Pipe({
  name: 'stringToNumber'
})
export class StringToNumber implements PipeTransform {

  transform(decimal: any, splitBy: string, parse = 'int') {
    let parseBy = {
      int: parseInt,
      float: parseFloat
    }
    if (typeof decimal === 'string') {
      let str = decimal.split(splitBy);
      if (str[1] === undefined) str[1] = '0';
      const hh = str[0].length === 1 ? '0' + str[0] : str[0];
      const min = str[1].length === 1 ? str[1] + '0' : str[1];
      return parseBy[parse](hh + '.' + min);
    } else {
      return 'ERR'
    }
  }
}


@Pipe({
  name: 'time24To12'
})
export class Time24To12 implements PipeTransform {

  transform(time: any) {

    // Check correct time format and split into components
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) { // If time format correct
      time = time.slice(1);  // Remove full string match value
      time[5] = +time[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(''); // return adjusted time or original string
  }
}

function AvatarImage(letters, size) {
  var canvas = document.createElement('canvas');
  var context = canvas.getContext("2d");
  var size = size || 60;
  // Generate a random color every time function is called
  // 0xFFFFFF
  // 0
  const alpha = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', ' ', '#', '-', '.'];
  const colors = ["#EF5350", "#E53935", // red
    "#E91E63", "#C2185B", "#AD1457", "#880E4F", // pink
    "#9C27B0", "#7B1FA2", "#4A148C", //purple
    "#673AB7", "#512DA8", "#311B92",  // deep purple "#651FFF"
    "#3F51B5", "#3949AB", "#283593", "#304FFE", //Indigo
    "#2196F3", "#1976D2", "#1565C0", "#0D47A1",  // blue "#2962FF",
    "#009688", "#00796B", "#388E3C", //green
    "#AFB42B", "#9E9D24", "#827717", //lime
    "#F9A825", "#F57F17", // yellow
    "#FFA000", "#FF8F00", "#FF6F00", //Amber
    "#EF6C00", "#FF6D00", "#FF9100", //orange
    "#FF5722", "#BF360C", "#DD2C00", // deep orange
    "#A1887F", "#8D6E63", "#795548", // brown
    "#757575", "#607D8B", "#546E7A" //grey

  ];
  const character = letters.slice(0, 1); let characterColor = '';
  if (character && character != '') {
    characterColor = colors[alpha.indexOf(character.toLowerCase())];
  }

  var color = "#" + (Math.random() * 0xFFFFFF << 0.8).toString(16);
  // Set canvas with & height
  canvas.width = size;
  canvas.height = size;
  // Select a font family to support different language characters
  // like Arial
  context.font = Math.round(canvas.width / 2) + "px Arial";
  context.textAlign = "center";
  // Setup background and front color
  context.fillStyle = characterColor || color;
  context.fillRect(0, 0, canvas.width, canvas.height);
  context.fillStyle = "#FFF";
  context.fillText(letters, size / 2, size / 1.5);
  // Set image representation in default format (png)
  let dataURI = canvas.toDataURL();
  // Dispose canvas element
  canvas = null;
  return dataURI;
}

@Pipe({
  name: 'awatarUri'
})
export class AwatarUri implements PipeTransform {

  transform(value: any, size: number = 25) {
    return AvatarImage(value.slice(0, 2), size)
  }

}

@Pipe({
  name: 'join'
})
export class JoinPipe implements PipeTransform {

  transform(value: any, deliminator: string = ',') {
    return Array.isArray(value) ? value.join(deliminator) : value
  }

}





@Pipe({ name: 'sanitizeHtml' })
export class SanitizeHtmlPipe implements PipeTransform {

  constructor(private _sanitizer: DomSanitizer) { }

  transform(value: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(value);
  }

}

@Pipe({ name: 'safeUrl' })
export class SanitizeUrlPipe implements PipeTransform {

  constructor(private _sanitizer: DomSanitizer) { }

  transform(value: string) {
    return this._sanitizer.bypassSecurityTrustUrl(value);
  }

}

@Pipe({ name: 'filterTable' })
export class FilterTablePipe implements PipeTransform {
  constructor(private _sanitizer: DomSanitizer) { }

  transform(value: any[], keys: any, filterValue: any) {
    if (filterValue == undefined || filterValue == '' || keys == undefined || keys == '' || keys == []) return value
    else {
      if (!Array.isArray(keys)) keys = [keys];
      return value.filter((item: any) => {
        for (let k = 0; k < keys.length; k++) {
          let key = keys[k];
          if (String(item[key]).toLowerCase().includes(filterValue.toLowerCase())) {
            return item;
            // console.log(item[filterKey].includes(key))
          }
        }
      });
    }
  }
}

@Pipe({ name: 'findName' })
export class FindNamePipe implements PipeTransform {
  constructor(private _sanitizer: DomSanitizer) { }

  transform(value: any, key: any, data: any[], returnValue: any) {
    let result = '---';
    if (returnValue == undefined || returnValue == '' || key == undefined || key == '') return result;
    if (!Array.isArray(data)) data = [data];
    data.filter((item) => {
      if (item[key] == value) {
        result = item[returnValue];
      }
    })
    return result;
  }
}

@Pipe({ name: 'truncate' })
export class TruncatePipe implements PipeTransform {
  constructor(private _sanitizer: DomSanitizer) { }

  transform(value: string, limit: number = 100, concatVal: string = '...') {
    return value.length > limit ? value.substring(0, limit) + concatVal : value;
  }
}

@Pipe({ name: 'complaintType' })
export class ComplaintTypePipe implements PipeTransform {
  constructor(private _sanitizer: DomSanitizer) { }

  transform(value: number) {
    let returnValue = 'low';
    if (value > 5) returnValue = 'moderate';
    if (value >= 10) returnValue = 'high';
    return returnValue;
  }
}

@Pipe({ name: 'objHaveValue' })
export class ObjHaveValue implements PipeTransform {
  constructor(private _sanitizer: DomSanitizer) { }

  transform(value: number,key:string,requiredValue:boolean = true) {
    try{
      if (value && value[key]){
        if(requiredValue) return value[key];
        else return true;
      }
      else{
        if(requiredValue) return '';
        else return false;
      }
    }catch(err){
      if(requiredValue) return '';
      else return false;
    }    
  }
}


/**
* Generate an avatar image from letters
*/
/*
https://ppolyzos.com/2015/09/27/generate-avatar-image-from-user-initials-through-canvas/
(function (w, d) {
    function AvatarImage(letters, size) {
      var canvas = d.createElement('canvas');
      var context = canvas.getContext("2d");
      var size = size || 60;
      // Generate a random color every time function is called
      var color =  "#" + (Math.random() * 0xFFFFFF << 0).toString(16);
      // Set canvas with & height
      canvas.width = size;
      canvas.height = size;
      // Select a font family to support different language characters
      // like Arial
      context.font = Math.round(canvas.width / 2) + "px Arial";
      context.textAlign = "center";
      // Setup background and front color
      context.fillStyle = color;
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.fillStyle = "#FFF";
      context.fillText(letters, size / 2, size / 1.5);
      // Set image representation in default format (png)
      dataURI = canvas.toDataURL();
      // Dispose canvas element
      canvas = null;
      return dataURI;
    }
    w.AvatarImage = AvatarImage;
  })(window, document);


  (function(w, d) {
  function generateAvatars() {
    var images = d.querySelectorAll('img[letters]');
    for (var i = 0, len = images.length; i < len; i++) {
      var img = images[i];
      img.src = AvatarImage(img.getAttribute('letters'), img.getAttribute('width'));
      img.removeAttribute('letters');
    }
  }
  d.addEventListener('DOMContentLoaded', function (event) {
      generateAvatars();
  });
})(window, document)

// <img width="60" height="60" letters="PP" />
  */